import './App.css';
import ColorBends from "./reactbits/ColorBends";
import BlobCursor from "./reactbits/BlobCursor";
import portrait from "./img/portrait_rishabhjoshi.png";
import dckwrth from "./img/dckwrth.png";
import spring from "./img/spring.png"
import spring2 from "./img/spring2.png"

function App() {
    const scrollToSection = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({behavior: "smooth"});
    };

    return (<div className="App">
            {/* Blob Cursor Effect */}
            <BlobCursor
                blobType="circle"
                fillColor="#5227FF"
                trailCount={5}
                sizes={[15, 30, 20]}
                innerSizes={[5, 10, 7]}
                innerColor="rgba(255,255,255,0.8)"
                opacities={[0.6, 0.6, 0.6]}
                shadowColor="rgba(0,0,0,0.75)"
                shadowBlur={50}
                shadowOffsetX={10}
                shadowOffsetY={10}
                filterStdDeviation={30}
                useFilter={true}
                fastDuration={0.01}
                slowDuration={0.1}
                zIndex={9999}
            />

            {/* Background Effect */}
            <div className="bg-wrapper">
                <ColorBends
                    colors={[ "#0d0d0d", "#1a1a1a", "#262626", "#8e44ad", "#c0392b", "#340101", "#001f3f", "#003f7f", "#5a4fcf", "#9b5de5", "#00bbf9", "#00f5d4" ]}
                    rotation={0}
                    speed={0.1}
                    scale={1.0}
                    frequency={5.0}
                    warpStrength={1.0}
                    mouseInfluence={7}
                    parallax={1}
                    noise={0.1}
                    transparent={true}
                />
            </div>

            {/* Navigation */}
            <nav className="navbar">
                <div className="nav-links">
                    <a href="#about">About</a>
                    <a href="#projects">Projects</a>
                    <a href="#skills">Skills</a>
                    <a href="#contact">Contact</a>
                </div>
            </nav>

            {/* Content */}
            <div className="content">
                {/* Hero Section */}
                <section id="home" className="hero">
                    <div className="hero-badge">
                        <span className="hero-badge-icon">💻</span>
                        Software Engineer @ Centris AG (2020–2024)
                    </div>
                    <h1 className="hero-title">
                        Software Engineer & Full-Stack Developer
                    </h1>
                    <p className="hero-subtitle">
                        I'm a Computer Science student at FHNW, passionate about designing and building robust, scalable full-stack applications.                    </p>
                    <div className="hero-buttons">
                        <button
                            className="btn-primary"
                            onClick={() => scrollToSection("projects")}
                        >
                            View Projects
                        </button>
                        <button
                            className="btn-secondary"
                            onClick={() => scrollToSection("contact")}
                        >
                            Get in Touch
                        </button>
                    </div>
                </section>

                {/* About Section */}
                <section id="about" className="section">
                    <h2 className="section-title">About Me</h2>
                    <p className="section-subtitle">
                        Apprentice-trained software engineer with experience in full-stack development,
                        APIs, testing and change management at Centris AG in Solothurn.
                    </p>
                    <div className="about-content">
                        <div className="about-image">
                            <img
                                src={portrait}
                                alt="Portrait of Rishabh Joshi"
                                className="about-image-photo"
                            />
                        </div>
                        <div className="about-text">
                            <h3>Hello, I&apos;m Rishabh</h3>
                            <p>
                                I completed a four year Software Engineer Apprenticeship at Centris AG, where I worked
                                on the Swiss Healthcare Platform and several internal applications. My responsibilities
                                grew from testing and troubleshooting existing systems to contributing as a full stack
                                developer in Solution Engineering.
                            </p>
                            <p>
                                My background combines strong computer science fundamentals from my vocational education
                                in Solothurn with practical experience in software development, web technologies, API
                                design and test management. I enjoy working in collaborative environments and I am
                                comfortable taking responsibility for complex tasks.
                            </p>
                            <p>
                                I am motivated by building software that matters, whether it is an internal command line
                                application that improves workflows or a public facing web platform used by many people.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Skills Section */}
                <section id="skills" className="section">
                    <h2 className="section-title">Skills</h2>
                    <p className="section-subtitle">
                        A mix of programming languages, web technologies and frameworks I&apos;ve used
                        in projects, school and at Centris AG.
                    </p>

                    {/* Glass container for skills */}
                    <div className="skills-section">
                        <div className="skills-grid">
                            <div className="skills-category">
                                <h4>Languages</h4>
                                <p>From low-level to web and scripting.</p>
                                <div className="skills-list">
                                    <span className="skill-tag">C</span>
                                    <span className="skill-tag">C++</span>
                                    <span className="skill-tag">Java</span>
                                    <span className="skill-tag">JavaScript</span>
                                    <span className="skill-tag">TypeScript</span>
                                    <span className="skill-tag">Python</span>
                                    <span className="skill-tag">PHP</span>
                                    <span className="skill-tag">SQL</span>
                                    <span className="skill-tag">HTML5</span>
                                    <span className="skill-tag">CSS3</span>
                                </div>
                            </div>

                            <div className="skills-category">
                                <h4>Web & Frameworks</h4>
                                <p>Tools I use to ship applications and prototypes.</p>
                                <div className="skills-list">
                                    <span className="skill-tag">React.js</span>
                                    <span className="skill-tag">React Native</span>
                                    <span className="skill-tag">Vue.js</span>
                                    <span className="skill-tag">Angular.js</span>
                                    <span className="skill-tag">Node</span>
                                    <span className="skill-tag">Spring</span>
                                    <span className="skill-tag">Three.js</span>
                                    <span className="skill-tag">Framer</span>
                                </div>
                            </div>

                            <div className="skills-category">
                                <h4>Tools & Platforms</h4>
                                <p>DevOps, testing and collaboration.</p>
                                <div className="skills-list">
                                    <span className="skill-tag">Git</span>
                                    <span className="skill-tag">Docker</span>
                                    <span className="skill-tag">Jenkins</span>
                                    <span className="skill-tag">Jira</span>
                                    <span className="skill-tag">Confluence</span>
                                    <span className="skill-tag">Postman</span>
                                </div>
                            </div>

                            <div className="skills-category">
                                <h4>Databases</h4>
                                <p>Data storage and querying.</p>
                                <div className="skills-list">
                                    <span className="skill-tag">PostgreSQL</span>
                                    <span className="skill-tag">MySQL</span>
                                    <span className="skill-tag">MongoDB</span>
                                    <span className="skill-tag">Oracle</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Projects Section */}
                <section id="projects" className="section">
                    <h2 className="section-title">Projects</h2>
                    <p className="section-subtitle">
                        A few projects that reflect how I like to work: practical, focused and
                        grounded in real use cases.
                    </p>
                    <div className="projects-grid">
                        {/* CLI Application for Testdata-Suite */}
                        <div className="project-card">
                            <div className="project-image">
                                <img
                                    src={spring}
                                    alt="Spring Logo"
                                    className="project-image-photo"
                                />
                            </div>
                            <div className="project-info">
                                <h3>CLI Application for Testdata-Suite (IPA)</h3>
                                <p>
                                    Final apprenticeship project: a Command Line Interface for the
                                    internal Testdata-Suite at Centris AG. Built in 10 days to
                                    automate copy operations of electronic test data between systems,
                                    reducing manual work in the web UI and enabling scheduler-driven
                                    processing chains.
                                </p>
                                <div className="project-tags">
                                    <span className="project-tag">Java</span>
                                    <span className="project-tag">Spring</span>
                                    <span className="project-tag">CLI</span>
                                    <span className="project-tag">Test Automation</span>
                                </div>
                            </div>
                        </div>

                        {/* Duckworth Decoded */}
                        <div className="project-card">
                            <div className="project-image">
                                <img
                                    src={dckwrth}
                                    alt="Duckworth Decoded Logo"
                                    className="project-image-photo"
                                />
                            </div>
                            <div className="project-info">
                                <h3>Duckworth Decoded</h3>
                                <p>
                                    A React.js platform dedicated to Kendrick Lamar&apos;s artistry,
                                    analyzing his entire discography in depth. Designed for enthusiasts
                                    and scholars who want a structured, interactive way to explore his
                                    work.
                                    {" "}
                                    <a
                                        href="https://duckworth-decoded.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{color: "#a78bfa", textDecoration: "underline"}}
                                    >
                                        duckworth-decoded.com
                                    </a>
                                </p>
                                <div className="project-tags">
                                    <span className="project-tag">React.js</span>
                                    <span className="project-tag">Frontend</span>
                                    <span className="project-tag">Content Platform</span>
                                </div>
                            </div>
                        </div>

                        {/* Centris Internal Work */}
                        <div className="project-card">
                            <div className="project-image">
                                <img
                                    src={spring2}
                                    alt="Duckworth Decoded Logo"
                                    className="project-image-photo"
                                />
                            </div>
                            <div className="project-info">
                                <h3>Swiss Healthcare Platform – Internal Tools</h3>
                                <p>
                                    Ongoing work during my apprenticeship and time as Full-Stack Developer:
                                    contributing to internal applications, APIs and testing activities for
                                    the Swiss Healthcare Platform. Involved in Solution Engineering,
                                    change management and troubleshooting complex production issues.
                                </p>
                                <div className="project-tags">
                                    <span className="project-tag">Full-Stack</span>
                                    <span className="project-tag">APIs</span>
                                    <span className="project-tag">Testing</span>
                                    <span className="project-tag">Change Management</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Contact Section */}
                <section id="contact" className="section">
                    <h2 className="section-title">Let&apos;s Connect</h2>
                    <p className="section-subtitle">
                        Interested in working together or just want to talk about software,
                        healthcare tech or side projects? Reach out anytime.
                    </p>

                    <div className="contact-section">
                        <div className="contact-grid">
                            <div className="contact-card">
                                <h4>Email</h4>
                                <p>Best way to reach me for collaborations, opportunities or questions.</p>
                                <a
                                    href="mailto:rishabh.joshi@outlook.com"
                                    className="contact-pill"
                                >
                                    rishabh.joshi@outlook.com
                                </a>
                            </div>

                            <div className="contact-card">
                                <h4>LinkedIn</h4>
                                <p>Let&apos;s connect professionally and stay in touch.</p>
                                <a
                                    href="https://www.linkedin.com/in/rishabh-joshi-0b307b1a3/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact-pill"
                                >
                                    linkedin.com/in/rishabh-joshi-0b307b1a3
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Footer */}
                <footer className="footer">
                    <p>© 2025 Rishabh Joshi. Built with React and Threejs.</p>
                </footer>
            </div>
        </div>);
}

export default App;